import { useEffect, useRef, useState } from "react";
import ProjectList from "./ProjectList";
import ParticipantsList from "./ParticipantsList";
import axios from "axios";
import StatusAndIssues from "./StatusAndIssues.js";
import { calculateEditablePeriod } from "../utils.js";
import { useSelector } from "react-redux";
import { canEditAllReportProjects, getReportDivision } from "../access";

const Report = ({ handleClickMenu, setYearMonth, yearMonth }) => {
  const userInfo = useSelector((state) => state.userInfo);
  const canEditAllProjects = canEditAllReportProjects(userInfo);
  const hasOwnReportDivision = getReportDivision(userInfo.div) === userInfo.div;
  const [modPeriod, setModPeriod] = useState(null);
  const [projectInfo, setProjectInfo] = useState({
    contrNo: null,
    isMyProject: false,
    isEnrollmentStatusUsed: true,
  });

  const [fullScreen, setFullScreen] = useState(false);

  const projectListRef = useRef(null);

  const isEditablePeriod =
    modPeriod !== null &&
    (modPeriod === 999 || calculateEditablePeriod(yearMonth, modPeriod));

  useEffect(() => {
    //* 수정가능기간
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/mthlyReport/config?item=01`
      )
      .then((res) => {
        setModPeriod(Number(res.data.value));
      });
  }, []);

  return (
    <>
      <ProjectList
        handleClickMenu={handleClickMenu}
        projectListRef={projectListRef}
        projectInfo={projectInfo}
        setProjectInfo={setProjectInfo}
        setYearMonth={setYearMonth}
        yearMonth={yearMonth}
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
      />
      {projectInfo.contrNo && !fullScreen && (
        <>
          <ParticipantsList
            contrNo={projectInfo.contrNo}
            yearMonth={yearMonth}
          />
          <StatusAndIssues
            contrNo={projectInfo.contrNo}
            isEditable={
              isEditablePeriod &&
              ((projectInfo.isMyProject && hasOwnReportDivision) || canEditAllProjects)
            }
            isEnrollmentStatusUsed={projectInfo.isEnrollmentStatusUsed}
            projectListRef={projectListRef}
            yearMonth={yearMonth}
          />
        </>
      )}
    </>
  );
};

export default Report;
